module.exports = __webpack_public_path__ + "img/block_5.dae72a3f.webp";